import React, {useState} from 'react';
import BurgerSidebar from "../../images/burger-sidebar.jpg";
import {bubble as MenuBubble} from "react-burger-menu";
import {Link} from "react-router-dom";

const Sidebar = () => {

    const [ menuOpen, setMenuOpen ] = useState(false);

    const handleStateChange = (state) => {
        setMenuOpen(state.isOpen);
    }

    const closeMenu = () => {
        setMenuOpen(false);
        window.scrollTo(0,0);
    }

    return (
        <MenuBubble pageWrapId={"page-wrap"} outerContainerId={"outer-container"} isOpen={menuOpen} onStateChange={(state) => handleStateChange(state)} >
            <Link exact="true" to="/" id="home" className="menu-item" onClick={() => closeMenu()}>Home</Link>
            <Link to="/about" id="about" className="menu-item" onClick={() => closeMenu()}>About</Link>
            <Link to="/contact" id="contact" className="menu-item" onClick={() => closeMenu()}>Contact</Link>
            <a href="https://www.npmjs.com/package/react-burger-menu" className="button-package">Package</a>

            <div className="burger-sidebar bestof-wrap">
                <img src={BurgerSidebar} alt="Burger sidebar" className="bestof-bg"/>
                <div className="bestof-content">
                    <h2>Best of!</h2>
                </div>
            </div>

            <div className="credits-images">
                <h3>Credits images & photos</h3>
                <p><a href="https://www.piqsels.com/">Piqsels.com</a></p>
                <p><a href="https://www.pexels.com/">Pexels.com</a></p>
                <p><a href="https://thispersondoesnotexist.com/">Thispersondoesnotexist.com</a></p>
            </div>
        </MenuBubble>
    );
};

export default Sidebar;
